import React, { useState } from "react";
import { CONFIG_TEXTOS_ACOPIO } from "../../../../config/textosAcopio";
import { AlmacenRow } from "./AlmacenRow";
import { AyudaAccionesModal } from "./AyudaAccionesModal";

export const AlmacenesTable = ({
    almacenes = [],
    estaCerrado,
    setAlmacenInvReajuste,
    ActualizarEstadoAlmacen,
    categoriaAcopio,
    verIngresosAlmacen,
}) => {
    const textConfig = CONFIG_TEXTOS_ACOPIO[categoriaAcopio];
    const [ayudaAbierta, setAyudaAbierta] = useState(false);

    return (
        <React.Fragment>
            <div className="new-table-wrapper almacenes-inventario__table-wrapper sticky-header sticky-first-column">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th rowSpan={2}>Almacén</th>
                            <th rowSpan={2}>Tipo de materia prima</th>
                            <th colSpan={2}>Inventario inicial</th>
                            <th colSpan={2}>Ingresos</th>
                            <th colSpan={2}>Sobrante IDs</th>
                            <th colSpan={2}>Peso sobrante almacenes</th>
                            <th colSpan={2}>{textConfig.textoEnvio}</th>
                            <th colSpan={3}>Inventario final</th>
                            <th rowSpan={2}>
                                Acciones
                                {!estaCerrado && (
                                    <button
                                        type="button"
                                        className="almacenes-inventario__ayuda-btn"
                                        title="Ver descripción de las acciones"
                                        onClick={() => setAyudaAbierta(true)}
                                    >
                                        ?
                                    </button>
                                )}
                            </th>
                        </tr>
                        <tr>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th>Laboratorio</th>
                            <th>Liquidación</th>
                            <th className="almacenes-inventario__status-cell">
                                Estado
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {almacenes.length === 0 && (
                            <tr>
                                <td colSpan={15} className="text-center">
                                    No hay almacenes disponibles.
                                </td>
                            </tr>
                        )}
                        {almacenes.map((item) => {
                            return (
                                <AlmacenRow
                                    key={item.inventario_almacen_id}
                                    item={item}
                                    estaCerrado={estaCerrado}
                                    setAlmacenInvReajuste={setAlmacenInvReajuste}
                                    ActualizarEstadoAlmacen={
                                        ActualizarEstadoAlmacen
                                    }
                                    verIngresosAlmacen={verIngresosAlmacen}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <AyudaAccionesModal
                open={ayudaAbierta}
                onClose={() => setAyudaAbierta(false)}
                textConfig={textConfig}
                incluyeReproceso={
                    textConfig.mostrarNotaReproceso &&
                    almacenes.some((item) => item.es_reproceso)
                }
            />
        </React.Fragment>
    );
};
